import { Pipe, PipeTransform } from '@angular/core';

/**
 * CapitalizePipe
 * Ex: 'angular é top' → 'Angular é top'
 * Preserva acrônimos em maiúsculas: 'sua avaliação SOAR' → 'Sua avaliação SOAR'
 */
@Pipe({ name: 'capitalize', standalone: true })
export class CapitalizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value?.length) return '';
    // Capitaliza apenas a primeira letra do texto, preservando o resto (incluindo SOAR em maiúsculas)
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}

/**
 * TitlecasePipe
 * Ex: 'angular é top' → 'Angular É Top'
 */
@Pipe({ name: 'titlecase', standalone: true })
export class TitlecasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value?.length) return '';
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }
}

/**
 * TrimPipe
 * Ex: '  texto  ' → 'texto'
 */
@Pipe({ name: 'trim', standalone: true })
export class TrimPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value?.trim?.() ?? '';
  }
}

/**
 * SlicePipe
 * Ex: 'angular' | slice:0:3 → 'ang'
 */
@Pipe({ name: 'slice', standalone: true })
export class SlicePipe implements PipeTransform {
  transform(value: string | null | undefined, start: number, end?: number): string {
    return value?.slice?.(start, end) ?? '';
  }
}

/**
 * UppercasePipe
 * Ex: 'angular' → 'ANGULAR'
 */
@Pipe({ name: 'uppercase', standalone: true })
export class UppercasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value?.toUpperCase?.() ?? '';
  }
}

export const TextPipes = [CapitalizePipe, TitlecasePipe, TrimPipe, SlicePipe, UppercasePipe];

/**
 * Exemplo de uso das interpolações no HTMl e suas respectivas saídas
 * {{ 'angular é bom' | capitalize }}   <!-- Angular é bom -->
 * {{ 'angular é bom' | titlecase }}    <!-- Angular É Bom -->
 * {{ '   texto feio   ' | trim }}      <!-- texto feio -->
 * {{ 'frontend' | slice:0:5 }}         <!-- front -->
 * {{ 'angular' | uppercase }}          <!-- ANGULAR -->
 */
